import styled from 'styled-components'

const Wrapper = styled.div`
  transform: translate3d (0, 0, 0);
  position: absolute;
  height: 100%;
  min-height: 568px;
  width: 100%;
  overflow: hidden;

  @media only screen and (max-width: 320px) {
    min-height: 320px;
  }
`
export { Wrapper }
